<template>
  <div id="app">
    <Header routeValue="1" ref="header" :productName="queryParam.productName"></Header>
    <content class="content-product" @mousedown="handleMouseLeave" @click="handleDel()">
      <div class="arrivals_box" v-if="productList.length>0">
        <div class="title_box">
          <div>
            <span class="hot">Hot </span>
            <span class="title">New Products</span>
          </div>
          <div
            class="des-wrapper"
            @click="goPageURL({key: 1, label: '/products/category/all-products'})"
            @mouseenter="isHovered = true"
            @mouseleave="isHovered = false"
          >
            <span class="des" :class="{ 'des-hover': isHovered }">
              Explore
              <img class="img" src="../assets/right-arrow.png" :class="{ 'img-hover': isHovered }"/>
            </span>
          </div>
        </div>
        <div class="swiper_box">
          <swiper ref="mySwiper" :options="swiperOption">
            <swiper-slide v-for="(item,index) in productList" :key="index">
              <div class="slide_box" :data-id="item.seoCustomerAddress">
                <div class="img_box">
                  <img class="img1" :src="item.productImg|imgFilter(189)">
                  <img class="img2" :src="item.productTemplateImg|imgFilter(189)">
                </div>
              </div>
            </swiper-slide>
          </swiper>
          <div class="button-prev">
            <img src="../assets/prev.png">
          </div>
          <div class="button-next">
            <img src="../assets/next.png">
          </div>
        </div>
      </div>
      <div class="product_tab">
        <a-tabs type="card" v-model="currentTabTag" :animated="false" @change="callback">
          <a-tab-pane v-for="item in tabItems" :key="item.tag" :tab="item.tab">
            <span slot="tab" class="tab-item">
              <img class="img" :src="item.icon">
              {{ item.label }}
              <span style="font-weight: 300">({{ item.count }})</span>
              <img class="hot" src="../assets/hot.png" v-if="item.label==='EU/USA Made'">
            </span>
          </a-tab-pane>
        </a-tabs>
      </div>
      <div class="product_box">
        <a-row>
          <a-col span="5" style="margin-top: 70px">
            <div class="wishlist">
              <span
                class="wishlist-name"
                @click="wishlistSelect('wishlist')"
                :style="{ color: !isTopPicks && queryParam.productIds && queryParam.productIds.length > 0 ? '#012169' : '#222222' }"
              >Wishlist</span>
            </div>
            <div class="top-picks" v-if="hotSaleEnabled">
              <span
                class="top-picks-name"
                @click="topPicksSelect"
                :style="{ color: isTopPicks ? '#FF5C01' : '#222222' }"
              >Top Picks</span>
            </div>
            <div class="wishlist-divider" style="margin-left: 25px"></div>
            <a-menu
              style="width: 250px"
              :open-keys="openKeys"
              :default-open-keys="openKeys"
              :selected-keys="selectedKeys"
              @openChange="onOpenChange"
              mode="inline">
              <template v-for="menu in menuData">
                <template v-if="menu.children && menu.children.length > 0">
                  <a-sub-menu :key="menu.id">
                    <div slot="title"
                         style="display: flex; align-items: center; justify-content: space-between;font-size: 18px;font-weight: bold;color: #111111"
                         @click="handleItemClick(menu.id, 0,1, menu)">
                      <span class="menu">
                        {{ menu.name }} ({{ menu.productNumber || 0 }})
                      </span>
                      <a-icon
                        :style="{ transform: menu.menuOpen ? 'rotate(180deg)' : 'rotate(0deg)', transition: 'transform 0.3s',
                        position: 'absolute' ,right:'0px',paddingTop:'16px', fontSize:'12px',color:'#b8b7b7',width: '30px',height: '40px'}"
                        type="down">
                      </a-icon>
                    </div>
                    <template v-for="subMenu in menu.children">
                      <a-sub-menu v-if="subMenu.children && subMenu.children.length > 0" :key="subMenu.id">
                        <div slot="title" style="display: flex; align-items: center;padding-top: 4px;font-size: 18px"
                             @click="handleItemClick(subMenu.id,1, 2,menu)">
                          <span class="menu" :class="{'selected-menu2': selectedKeys.includes(subMenu.id)}"
                                style="font-size: 18px;font-weight: bold;color: #111111">
                            {{ subMenu.name }} ({{ subMenu.productNumber || 0 }})
                          </span>
                        </div>
                        <a-menu-item v-for="item in subMenu.children" :key="item.id"
                                     @click="handleItemClick(item.id,1,3,menu)">
                          <span class="menu3" style="font-size: 18px;font-weight: 400;color: #888A96"
                                :title="item.name+' ('+item.productNumber+')'"
                                :class="{'selected-menu3': selectedKeys.includes(item.id)}">
                            {{ item.name }} ({{ item.productNumber || 0 }})</span>
                        </a-menu-item>
                      </a-sub-menu>
                      <template v-else>
                        <a-menu-item :key="subMenu.id" @click="handleItemClick(subMenu.id,1,3,menu)"
                                     style="position: relative">
                          <span class="menu" style="font-size: 18px;font-weight: bold;color: #111111"
                                :class="{'selected-menu1': selectedKeys.includes(subMenu.id)}">
                            {{ subMenu.name }} ({{ subMenu.productNumber || 0 }})
                          </span>
                        </a-menu-item>
                      </template>
                    </template>
                  </a-sub-menu>
                </template>
                <template v-else>
                  <a-menu-item :key="menu.id"
                               style="font-weight: bold;font-size: 18px;color: #111111;position: relative;"
                               @click="handleItemClick(menu.id,1,1,menu)">
                    <span>
                      <div :class="{'selected-menu': selectedKeys.includes(menu.id)}">
                        <span class="menu">
                          {{ menu.name }} ({{ menu.productNumber || 0 }})
                        </span>
                      </div>
                    </span>
                  </a-menu-item>
                </template>
              </template>
            </a-menu>
            <div class="paused">
              <div class="paused-divider"></div>
              <span
                class="paused-name"
                @click="pausedSelect"
                :style="{ color: String(queryParam.status) === '2' ? '#012169' : '#222222' }"
              >Paused ({{ pausedProductNumber || 0 }})</span>
            </div>
          </a-col>
          <a-col span="19">
            <div class="shop_view" v-if="false">
              <span class="title">Shop by</span>
              <a-skeleton :loading="spinning" active :paragraph="{rows: 16}">
                <div class="shop_list" v-if="shopList.length>0">
                  <div class="shop_box" v-for="(item,index) in shopList" :key="index"
                       @click="handleItemClick(item.id, 4,3, item)">
                    <div class="img_box">
                      <img class="img1" :src="item.img|imgFilter(294)">
                      <img class="img2" :src="item.img|imgFilter(294)">
                    </div>
                    <span class="name">{{ item.name }}</span>
                  </div>
                </div>
                <div class="empty_box" v-else>
                  <img src="../assets/empty.png">
                </div>
              </a-skeleton>
            </div>
            <div class="product_view">
              <span class="title">{{ menuTitle }}</span>
              <div class="filtrate_box">
                <a-checkbox-group
                  :value="queryParam.tagIds"
                  class="checkbox_group"
                  v-if="isChinaTabSelected && !isTopPicks"
                >
                  <div :key="item.id" v-for="(item) in tagsList">
                    <a-checkbox :value="item.id" @change="(e)=>toggleSelect(item.id)" class="checkbox">
                      {{ item.name }}
                    </a-checkbox>
                  </div>
                </a-checkbox-group>
                <!-- 绑定 currentValueTag（us/de/us-de），只在 EU/USA 区显示 -->
                <a-radio-group
                  v-model="currentValueTag"
                  @change="onChange"
                  class="custom-radio-group"
                  v-else-if="!isChinaTabSelected"
                >
                  <a-radio-button
                    v-for="item in countryOptions"
                    :key="item.tag"
                    :value="item.tag"
                    class="custom-radio-item"
                  >
                    <div class="radio-content">
                      <img :src="item.icon" :alt="item.label" v-if="item.icon" class="country-icon"/>
                      <span>{{ item.label }} ({{ item.count }})</span>
                    </div>
                  </a-radio-button>
                </a-radio-group>
                <div class="filtrate-selects">
                  <a-select
                    placeholder="Price"
                    allowClear
                    v-model="priceRange"
                    @change="handleChange1($event, 0)"
                    style="width: 150px; margin-right: 3px"
                  >
                    <a-select-option
                      v-for="(item, index) in priceList"
                      :label="item.label"
                      :key="index"
                      :title="item.label"
                      :value="item.value"
                    >
                      <span v-if="selectedPrice">
                        <a-icon type="check" v-if="selectedPrice === item.value" class="check_icon"/>
                        <a-icon type="check" v-else class="check_icon" style="visibility: hidden"/>
                      </span>
                      <span class="tagName">&nbsp;&nbsp;{{ item.label }}</span>
                    </a-select-option>
                  </a-select>
                  <a-select
                    v-if="false"
                    placeholder="Fulfillment Location"
                    allowClear
                    v-model="queryParam.locationId"
                    @change="handleChange1($event, 1)"
                    style="width: 200px; margin-right: 10px"
                  >
                    <a-select-option
                      v-for="(item, index) in locationList"
                      :label="item.showName"
                      :key="index"
                      :title="item.showName"
                      :value="item.id"
                    >
                      <span v-if="selectedLocation">
                        <a-icon type="check" v-if="selectedLocation === item.id" class="check_icon"/>
                        <a-icon type="check" v-else class="check_icon" style="visibility: hidden"/>
                      </span>
                      <span class="tagName">&nbsp;&nbsp;{{ item.showName }}</span>
                    </a-select-option>
                  </a-select>
                  <div @mousedown.stop="handleMouseDown($event,0)" v-if="false">
                    <a-select placeholder="Price" :open="priceOpen" v-model="priceRange" allowClear
                              @change="handleChange($event,0)"
                              style="width: 150px">
                      <div slot="dropdownRender" slot-scope="menu">
                        <div
                          style="padding: 8px;  display: flex;align-items: center;justify-content: center;line-height: 1;">
                          <a-input v-model="queryParam.minPrice" @click.stop="handleInputClick"
                                   @input="handleInput(0)" style="height: 32px"/>
                          <span style="margin: 0 3px;">-</span>
                          <a-input v-model="queryParam.maxPrice" @click.stop="handleInputClick"
                                   @input="handleInput(0)" style="height: 32px"/>
                        </div>
                      </div>
                    </a-select>
                  </div>
                  <div @mousedown.stop="handleMouseDown($event,1)" v-if="false">
                    <a-select placeholder="Weight" :open="weightOpen" v-model="weightRange"
                              allowClear @change="handleChange($event,1)"
                              style="width: 150px;margin-left: 10px">
                      <div slot="dropdownRender" slot-scope="menu">
                        <div
                          style="padding: 8px;  display: flex;align-items: center;justify-content: center;line-height: 1;">
                          <a-input v-model="queryParam.minWeight" @click.stop="handleInputClick"
                                   @input="handleInput(1)" style="height: 32px"/>
                          <span style="margin: 0 3px;">-</span>
                          <a-input v-model="queryParam.maxWeight" @click.stop="handleInputClick"
                                   @input="handleInput(1)" style="height: 32px"/>
                        </div>
                      </div>
                    </a-select>
                  </div>
                  <div @mousedown.stop="handleMouseDown($event,2)" v-if="false">
                    <a-select placeholder="Production time" :open="timeOpen" v-model="timeRange"
                              allowClear @change="handleChange($event,2)"
                              style="width: 213px;margin-left: 10px">
                      <div slot="dropdownRender" slot-scope="menu">
                        <div
                          style="padding: 8px;display: flex;align-items: center;justify-content: center;line-height: 1;">
                          <a-input v-model="queryParam.performanceTime" @click.stop="handleInputClick"
                                   @input="handleInput(2)" style="height: 32px"/>
                          <span style="margin: 0 3px;">-</span>
                          <a-input v-model="queryParam.performanceTimeEnd" @click.stop="handleInputClick"
                                   @input="handleInput(2)" style="height: 32px"/>
                        </div>
                      </div>
                    </a-select>
                  </div>
                  <a-select v-model="queryParam.orderByType" placeholder="Sort by" allowClear
                            style="width: 150px;margin-left: 10px"
                            @change="handleChange($event,3)">
                    <a-select-option :value="0">
                      New arrivals
                    </a-select-option>
                    <a-select-option :value="1">
                      Price(high-low)
                    </a-select-option>
                    <a-select-option :value="2">
                      Price(low-high)
                    </a-select-option>
                  </a-select>
                </div>
              </div>
              <div class="total_box">
                We found {{ total }} related items for
                <template v-if="urlProductName">
                  <a-tag class="search-keyword-tag" :title="urlProductName">
                    <span class="search-keyword-quote">"</span>
                    <span class="search-keyword-text">{{ urlProductName }}</span>
                    <span class="search-keyword-quote">"</span>
                    <img
                      class="search-keyword-close"
                      src="../assets/tag_close.png"
                      alt="close"
                      @click="clearSearchKeyword"
                    >
                  </a-tag>
                </template>
                <template v-else>you</template>
              </div>
              <a-skeleton :loading="spinning" active :paragraph="{rows: 16}">
                <div class="product_list" v-if="dataList.length>0">
                  <div class="list_box" v-for="(item,index) in dataList" :key="index" @click="toDetailsDes(item)">
                    <div class="img_box">
                      <img class="img1" :src="item.productImg|imgFilter(360)">
                      <img class="img2" :src="item.productTemplateImg|imgFilter(360)">
                    </div>
                    <span class="name" :title="item.productNameEn">{{ item.productNameEn }}</span>
                    <span class="size">{{ item.spec }}</span>
                    <span class="size">
                      Production time {{ item.performanceTime }}-{{ item.performanceTimeEnd }}days
                    </span>
                    <span class="price">From USD {{ item.minPrice }}</span>
                    <div class="tag_box" v-if="false">
                      <img src="../assets/best@2x.png" v-if="isShowTag(item,'Bestsellers')" style="width: 74px">
                      <img src="../assets/new@2x.png" v-if="isShowTag(item,'New')" style="width: 40px">
                      <img src="../assets/trd@2x.png" v-if="isShowTag(item,'Trending')" style="width: 67px">
                    </div>
                    <div class="tag_box" v-if="currentTabTag==='cn' && !isTopPicks">
                      <span class="new" v-if="isShowTag(item,'New')">New</span>
                      <span class="best" v-if="isShowTag(item,'Bestsellers')">Bestseller</span>
                      <span class="trd" v-if="isShowTag(item,'Trending')">Trending</span>
                    </div>
                    <div class="product-operate" v-if="!isTopPicks">
                      <div :class="'collection ' + (collectIds.indexOf(item.id) > -1 ? 'collected':'') "
                           @click.stop="collect(item.id)"></div>
                    </div>
                  </div>
                </div>
                <div class="empty_box" v-else>
                  <img src="../assets/empty.png">
                </div>
              </a-skeleton>
              <div class="pagination" v-if="dataList.length>0">
                <a-pagination
                  :show-total="(total, range) => `${range[0]}-${range[1]} items, total ${total} items`"
                  show-size-changer
                  :page-size-options="['20', '40', '100']"
                  :current="queryParam.pageNum"
                  :total="total"
                  :page-size="queryParam.pageSize"
                  @change="changeSize"
                  @showSizeChange="onSizeChange"
                />
              </div>
            </div>
          </a-col>
        </a-row>
      </div>
    </content>
    <Footer></Footer>
  </div>
</template>

<script>
import Header from '../components/Header.vue'
import Footer from '../components/Footer.vue'
import {get, post} from '@/api'
import {
  findTopLevelParentId,
  getItemsById,
  getNamesById,
  getSeoLinkName,
  setOpenKeys,
  unSubmenus,
  findKeyByValue
} from '@/utils/utils'
import {swiper, swiperSlide} from 'vue-awesome-swiper'
import EventBus from '../router/event-bus.js'
import {syncRouteSeo} from '@/utils/seoHead'

export default {
  name: 'Products',
  components: {
    Header,
    Footer,
    swiper,
    swiperSlide
  },
  data () {
    return {
      menuTitle: '',
      isTopPicks: false,
      hotSaleEnabled: false,
      //tab（cn/other）、value（us/de/us-de）
      currentTabTag: 'cn',
      currentValueTag: '',
      filtersBootstrapped: false,
      cnProductNumber: 0,
      otherProductNumber: 0,
      pausedProductNumber: 0,
      selectNames: [],
      dataList: [],
      shopList: [],
      productList: [],
      tagsList: [],
      checkedList: [],
      menuData: [],
      collectIds: [],
      spinning: true,
      priceOpen: false,
      isHovered: false,
      isSelectedMenu: false,
      selectedPrice: undefined,
      selectedLocation: undefined,
      priceList: [
        {label: '0-10', value: 1},
        {label: '10-30', value: 2},
        {label: '>30', value: 3}
      ],
      otherLocationNumberMap: {},
      tabItems: [],
      countryOptions: [],
      locationList: [],
      weightOpen: false,
      timeOpen: false,
      priceRange: undefined,
      weightRange: undefined,
      timeRange: undefined,
      pageNum: 1,
      pageSize: 20,
      total: 0,
      urlProductName: '',
      queryParam: {
        pageNum: 1,
        pageSize: 20,
        categoryId: undefined,
        minPrice: undefined,
        maxPrice: undefined,
        minWeight: undefined,
        maxWeight: undefined,
        performanceTime: undefined,
        performanceTimeEnd: undefined,
        productName: undefined,
        orderByType: undefined,
        tagIds: [],
        productIds: [],
        locationId: undefined,
        locationIds: [],
        status: 0
      },
      swiperOption: {
        slidesPerView: 6,
        slidesPerGroup: 6,
        spaceBetween: 20,
        loop: true,
        loopFillGroupWithBlank: true,
        height: 200,
        navigation: {
          nextEl: '.button-next',
          prevEl: '.button-prev'
        },
        pagination: {
          el: '.swiper-pagination',
          clickable: true
        }
      },
      expandedMenu: new Map(),
      expandedMenuName: new Map(),
      openKeys: [],
      selectedKeys: [],
      rootSubmenuKeys: []
    }
  },
  computed: {
    isChina () {
      return this.currentTabTag === 'cn'
    },
    isChinaTabSelected () {
      return this.currentTabTag === 'cn'
    },
    currentLocationIds () {
      const tabItem = this.tabItems.find(item => item.tag === this.currentTabTag)
      return tabItem ? tabItem.key.split(',') : []
    },
    currentValueLocationIds () {
      const countryItem = this.countryOptions.find(item => item.tag === this.currentValueTag)
      return countryItem ? countryItem.key.split(',') : []
    },
    swiper () {
      return this.$refs.mySwiper.swiper
    },
    tagStyles () {
      const colorPalette = ['#FF5C01', '#0B550F', '#5F2282', '#343183']
      return this.tagsList.map((item, index) => {
        const isSelected = this.queryParam.tagIds.includes(item.id)
        const color = colorPalette[index % colorPalette.length]
        return {
          color: isSelected ? color : '#111111',
          separatorColor: isSelected ? color : 'transparent'
        }
      })
    }
  },
  watch: {
    currentTabTag (newVal) {
      if (!newVal || !this.filtersBootstrapped) return
      if (newVal === 'cn') {
        this.currentValueTag = newVal
      }
      this.updateUrlParams()
      this.getCategoryList()
    },
    currentValueTag (newVal) {
      if (!newVal || !this.filtersBootstrapped) return
      this.updateUrlParams()
      this.getProductList(0)
    },
  },
  mounted () {
    window.scrollTo({top: 0, behavior: 'smooth'})

    const that = this
    document.body.addEventListener('click', function (e) {
      if (e.target.closest('.slide_box')) {
        that.toDetailsDes({seoCustomerAddress: e.target.closest('.slide_box').getAttribute('data-id')})
      }
    })

    this.handleUrlChange = function handleUrlChange (event) {
      that.initFromUrlParams()
      that.syncPathSeo()
    }
    window.addEventListener('popstate', this.handleUrlChange)
    this.initFromUrlParams()
  },
  created () {
    this.queryParam.productName = this.$route.params.productName || this.$route.query.productName || undefined
    if (this.queryParam.productName) {
      this.queryParam.productName = String(this.queryParam.productName).replace(/\+/g, ' ')
    }
    const urlParams = new URLSearchParams(window.location.search)
    this.queryParam.categoryId = this.$route.query.categoryId || urlParams.get('categoryId') || undefined
    const urlString = window.location.href
    const tagId = urlString.split('tagId=')[1]
    this.queryParam.tagIds = tagId ? [tagId] : []
    this.queryParam.productIds = []
    this.syncUrlProductName()
    EventBus.$on('customEvent', this.handleCustomEvent)
    EventBus.$on('productTagsLoaded', this.onProductTagsLoaded)
    try {
      this.collectIds = JSON.parse(localStorage.getItem('collectIds') || '[]') || []
    } catch (e) {
      this.collectIds = []
    }
    this.getProductNewList()
    this.getProductLocation()
  },
  beforeDestroy () {
    EventBus.$off('customEvent', this.handleCustomEvent)
    EventBus.$off('productTagsLoaded', this.onProductTagsLoaded)
    window.removeEventListener('popstate', this.handleUrlChange)
  },
  methods: {
    syncPathSeo () {
      syncRouteSeo(window.location.pathname, this.$route.meta && this.$route.meta.title)
    },

    syncUrlProductName () {
      const name = new URLSearchParams(window.location.search).get('productName')
      this.urlProductName = name ? String(name).replace(/\+/g, ' ') : ''
    },

    clearSearchKeyword () {
      this.queryParam.productName = undefined
      this.queryParam.pageNum = 1
      this.updateUrlParams()
      this.getProductList()
    },

    // 初始化 URL 参数时，确保 other 区默认选中 us-de
    initFromUrlParams () {
      const urlParams = new URLSearchParams(window.location.search)
      // 优先读取旧参数，兼容历史链接
      let tabTag = urlParams.get('tab')
      let valueTag = urlParams.get('value')
      // 初始化 tabTag，默认 cn
      this.currentTabTag = tabTag || 'cn'
      // - cn 区：默认等于 cn
      // - other 区：优先取 URL 中的值，无则默认 us-de
      if (this.currentTabTag === 'cn') {
        this.currentValueTag = valueTag || this.currentTabTag
      } else {
        this.currentValueTag = valueTag || 'us-de' // other 区默认 us-de
      }
      this.queryParam.locationIds = this.isChina ? this.currentLocationIds : this.currentValueLocationIds
      this.queryParam.tagIds = []
      this.queryParam.productIds = []
      this.queryParam.categoryId = undefined
      const path = window.location.pathname || ''
      if (path.includes('/top-picks')) {
        this.isTopPicks = true
        this.queryParam.status = 0
        this.menuTitle = 'Top Picks'
        this.selectNames = ['Products', 'Top Picks']
      } else if (path.includes('/wishlist')) {
        this.isTopPicks = false
        this.queryParam.status = 0
        this.menuTitle = 'Wishlist'
        this.selectNames = ['Products', 'Wishlist']
        try {
          this.collectIds = JSON.parse(localStorage.getItem('collectIds') || '[]') || []
        } catch (e) {
          this.collectIds = []
        }
        this.queryParam.productIds = this.collectIds.length <= 0 ? ['mmmmmmmmmm'] : this.collectIds
      } else if (path.includes('/paused')) {
        this.isTopPicks = false
        this.queryParam.status = 2
        this.menuTitle = 'Paused'
        this.selectNames = ['Products', 'Paused']
      } else {
        this.isTopPicks = false
        if (String(this.queryParam.status) !== '2') {
          this.queryParam.status = 0
        }
      }
      this.cleanOldUrlParams()
    },

    // 用 encodeURIComponent 拼 query，空格为 %20，避免 URLSearchParams 编成 +
    buildQueryString (params) {
      const parts = []
      Object.keys(params).forEach(key => {
        const val = params[key]
        if (val !== undefined && val !== null && val !== '') {
          parts.push(encodeURIComponent(key) + '=' + encodeURIComponent(String(val)))
        }
      })
      return parts.length ? '?' + parts.join('&') : ''
    },

    getUrlQueryParams () {
      const params = {
        tab: this.currentTabTag
      }
      if (this.currentTabTag === 'other') {
        params.value = this.currentValueTag
      }
      if (this.queryParam.categoryId) {
        params.categoryId = this.queryParam.categoryId
      }
      if (this.queryParam.productName) {
        params.productName = this.queryParam.productName
      }
      return params
    },

    // 清理旧的URL参数（tab/value），只保留新参数
    cleanOldUrlParams () {
      const url = new URL(window.location.href)
      // 初始化时从地址栏带回 productName
      const productNameFromUrl = url.searchParams.get('productName')
      if (productNameFromUrl && !this.queryParam.productName) {
        this.queryParam.productName = productNameFromUrl
      }
      window.history.replaceState({}, '', url.pathname + this.buildQueryString(this.getUrlQueryParams()))
      this.syncUrlProductName()
    },

    updateUrlParams () {
      const url = new URL(window.location.href)
      window.history.replaceState({}, '', url.pathname + this.buildQueryString(this.getUrlQueryParams()))
      this.syncUrlProductName()
    },

    onOpenChange (openKeys) {
    },

    wishlistSelect () {
      try {
        this.collectIds = JSON.parse(localStorage.getItem('collectIds') || '[]') || []
      } catch (e) {
        this.collectIds = []
      }
      this.isTopPicks = false
      this.queryParam.productIds = this.collectIds.length <= 0 ? ['mmmmmmmmmm'] : this.collectIds
      this.queryParam.tagIds = []
      this.queryParam.categoryId = undefined
      this.queryParam.status = 0
      this.openKeys = []
      if (this.collectIds && this.collectIds.length > 0) {
        this.selectedKeys = []
      } else {
        this.selectedKeys = []
        this.queryParam.productIds = ['mmmmmmmmmm']
      }
      this.menuData.forEach(item => {
        item.menuOpen = false
      })
      this.menuTitle = 'Wishlist'
      this.selectNames = ['Products', this.menuTitle]
      this.queryParam.pageNum = 1
      this.setSpecialCategoryUrl('wishlist')
      this.getProductList()
    },

    pausedSelect () {
      this.isTopPicks = false
      this.queryParam.status = 2
      this.queryParam.tagIds = []
      this.queryParam.productIds = []
      this.queryParam.categoryId = undefined
      this.openKeys = []
      this.selectedKeys = []
      this.menuData.forEach(item => {
        item.menuOpen = false
      })
      this.menuTitle = 'Paused'
      this.selectNames = ['Products', 'Paused']
      this.queryParam.pageNum = 1
      this.setSpecialCategoryUrl('paused')
      this.getProductList()
    },

    topPicksSelect () {
      this.isTopPicks = true
      this.queryParam.status = 0
      this.queryParam.productIds = []
      this.queryParam.tagIds = []
      this.queryParam.categoryId = undefined
      this.openKeys = []
      this.selectedKeys = []
      this.menuData.forEach(item => {
        item.menuOpen = false
      })
      this.menuTitle = 'Top Picks'
      this.selectNames = ['Products', this.menuTitle]
      this.queryParam.pageNum = 1
      this.setSpecialCategoryUrl('top-picks')
      this.getProductList()
    },

    setSpecialCategoryUrl (slug) {
      const href = new URL(location.origin)
      const newUrl = `${href}products/category/${slug}${this.getUrlParamsString()}`
      window.history.pushState({}, '', newUrl)
      this.isSelectedMenu = true
      this.syncUrlProductName()
      this.syncPathSeo()
    },

    setTopPicksUrl () {
      this.setSpecialCategoryUrl('top-picks')
    },

    toggleSelect (selectedId) {
      this.queryParam.productIds = []
      const index = this.queryParam.tagIds.indexOf(selectedId)
      if (index > -1) {
        this.queryParam.tagIds.splice(index, 1)
      } else {
        this.queryParam.tagIds = [selectedId]
      }
      this.queryParam.categoryId = undefined
      this.queryParam.status = 0
      this.openKeys = []
      this.selectedKeys = []
      this.menuData.forEach(item => {
        item.menuOpen = false
      })
      if (!this.isTopPicks) {
        this.menuTitle = 'All products'
        this.selectNames = ['Products', this.menuTitle]
        this.selectedKeys = [String('')]
        this.setNewUrl('')
      } else {
        this.menuTitle = 'Top Picks'
        this.selectNames = ['Products', this.menuTitle]
        this.setTopPicksUrl()
      }
      this.queryParam.pageNum = 1
      this.getProductList()
    },

    isSelected (id) {
      return this.queryParam.tagIds.includes(id)
    },

    handleCustomEvent (data, type) {
      this.clearFilters()
      this.queryParam.productName = data
      if (type === 1) {
        this.isTopPicks = false
        this.queryParam.tagIds = []
        this.queryParam.productIds = []
        this.selectedKeys = []
        this.handleItemClick('', 2)
        this.menuData.forEach(item => {
          item.menuOpen = false
        })
        EventBus.$emit('event', this.queryParam.productName)
      } else if (type === 2) {
        this.isTopPicks = false
        this.selectedKeys = ['']
        this.openKeys = []
        this.queryParam.tagIds = []
        this.queryParam.productIds = []
        this.queryParam.categoryId = undefined
        this.queryParam.status = 0
        this.menuTitle = 'All products'
        this.selectNames = ['Products', 'All products']
        this.isSelectedMenu = false

        // 重置菜单展开状态
        this.menuData.forEach(item => {
          item.menuOpen = false
          if (item.children) {
            item.children.forEach(subItem => {
              subItem.submenuOpen = false
              if (subItem.children) {
                subItem.children.forEach(subSubItem => {
                  subSubItem.submenuOpen = false
                })
              }
            })
          }
        })
        // URL / SEO：由 Header $router.push → afterEach syncRouteSeo 统一处理，避免与 syncPathSeo 各拉一次
        this.currentTabTag = 'cn'
        this.currentValueTag = 'cn'
        this.queryParam.locationIds = this.currentLocationIds
        window.scrollTo({top: 0, behavior: 'smooth'})
        this.queryParam.pageNum = 1
        if (window.location.pathname !== '/products/category/all-products') {
          const href = new URL(location.origin)
          window.history.replaceState({}, '', `${href}products/category/all-products${this.getUrlParamsString()}`)
          this.syncUrlProductName()
        } else {
          this.updateUrlParams()
        }
        this.isSelectedMenu = true
        this.getProductList(0)
      }
    },

    handleMouseDown (event, type) {
      event.preventDefault()
      if (type === 0) {
        this.priceOpen = !this.priceOpen
        this.weightOpen = false
        this.timeOpen = false
      } else if (type === 1) {
        this.weightOpen = !this.weightOpen
        this.priceOpen = false
        this.timeOpen = false
      } else if (type === 2) {
        this.timeOpen = !this.timeOpen
        this.priceOpen = false
        this.weightOpen = false
      }
    },
    clearFilters () {
      this.selectedPrice = undefined
      this.queryParam.orderByType = undefined
      this.priceRange = undefined
      this.queryParam.minPrice = undefined
      this.queryParam.maxPrice = undefined
      this.queryParam.selectedLocation = undefined
    },
    callback () {
      // 1. 中国区：currentValueTag 自动等于 currentTabTag，清空 tagIds
      if (this.currentTabTag === 'cn') {
        this.currentValueTag = this.currentTabTag
        this.queryParam.tagIds = [] // 清空 tagIds
        this.queryParam.productIds = [] // 清空 productIds
      }
      // 2. EU/USA 区：强制默认选中 us-de，清空 tagIds
      else if (this.currentTabTag === 'other') {
        this.currentValueTag = 'us-de' // 固定默认选中 us-de
        this.queryParam.tagIds = [] // 清空 tagIds
        this.queryParam.productIds = [] // 清空 productIds
      }
      // 同步 locationIds（us-de 对应的所有地区）
      this.queryParam.locationIds = this.currentLocationIds
      if (String(this.queryParam.status) !== '2') {
        this.queryParam.status = 0
      }
      this.clearFilters()
      this.updateUrlParams()
      // 列表由 watch currentValueTag / currentTabTag 拉取，避免与 tab @change 重复请求
    },

    // 生成 URL 参数串：只保留必要的（空格编码为 %20）
    getUrlParamsString () {
      return this.buildQueryString(this.getUrlQueryParams())
    },

    handleDel () {
      this.$refs.header.delProductValue()
    },

    goPageURL (item) {
      if (item.key === 1) {
        this.handleCustomEvent(undefined, 2)
      }
      if (this.$route.path !== item.label) {
        this.$router.push({path: item.label})
      }
    },

    handleMouseLeave () {
      if (this.priceOpen || this.weightOpen || this.timeOpen) {
        this.queryParam.pageNum = 1
        this.getProductList()
      }
      this.priceOpen = false
      this.weightOpen = false
      this.timeOpen = false
    },

    // 切换国家（us/de/us-de），只在 EU/USA 区生效
    onChange () {
      this.queryParam.locationIds = this.currentValueLocationIds
      this.updateUrlParams()
      this.getProductList(0)
    },

    handleInputClick (event, type) {
      event.target.focus()
    },

    handleInput (type) {
      if (type === 0) {
        const minPrice = this.queryParam.minPrice
        const maxPrice = this.queryParam.maxPrice
        let value
        if (minPrice && maxPrice) {
          value = `${minPrice} - ${maxPrice}`
        } else if (minPrice) {
          value = `>=${minPrice}`
        } else if (maxPrice) {
          value = `<=${maxPrice}`
        } else {
          value = undefined
        }
        this.priceRange = value ? value + '$' : value
      } else if (type === 1) {
        const minWeight = this.queryParam.minWeight
        const maxWeight = this.queryParam.maxWeight
        let value
        if (minWeight && maxWeight) {
          value = `${minWeight} - ${maxWeight}`
        } else if (minWeight) {
          value = `>=${minWeight}`
        } else if (maxWeight) {
          value = `<=${maxWeight}`
        } else {
          value = undefined
        }
        this.weightRange = value ? value + 'G' : value
      } else if (type === 2) {
        const performanceTime = this.queryParam.performanceTime
        const performanceTimeEnd = this.queryParam.performanceTimeEnd
        let value
        if (performanceTime && performanceTimeEnd) {
          value = `${performanceTime} - ${performanceTimeEnd}`
        } else if (performanceTime) {
          value = `>=${performanceTime}`
        } else if (performanceTimeEnd) {
          value = `<=${performanceTimeEnd}`
        } else {
          value = undefined
        }
        this.timeRange = value ? value + 'Day' : value
      }
    },

    handleChange1 (e, type) {
      if (type === 0) {
        this.selectedPrice = e
        this.queryParam.minPrice = e === 1 ? '0' : e === 2 ? '10' : e === 3 ? '31' : undefined
        this.queryParam.maxPrice = e === 1 ? '10' : e === 2 ? '30' : e === 3 ? undefined : undefined
        const minPrice = this.queryParam.minPrice
        const maxPrice = this.queryParam.maxPrice
        let value
        if (minPrice && maxPrice) {
          value = `${minPrice} - ${maxPrice}`
        } else if (minPrice) {
          value = `>30`
        } else {
          value = undefined
        }
        this.priceRange = value ? value + '$' : value
      } else if (type === 1) {
        this.selectedLocation = e
      }
      this.queryParam.pageNum = 1
      this.getProductList()
    },

    handleChange (value, type) {
      if (type === 0) {
        this.queryParam.minPrice = value
        this.queryParam.maxPrice = value
      } else if (type === 1) {
        this.queryParam.minWeight = value
        this.queryParam.maxWeight = value
      } else if (type === 2) {
        this.queryParam.performanceTime = value
        this.queryParam.performanceTimeEnd = value
      } else if (type === 3) {
        this.queryParam.orderByType = value
      }
      this.queryParam.pageNum = 1
      this.getProductList()
    },

    getProductNewList () {
      get('/index/product/new')
        .then(response => {
          this.productList = response.data
          this.productList.forEach(item => {
            if (!item.productTemplateImg) item['productTemplateImg'] = item.productImg
          })
        })
        .catch(error => console.error(error))
    },

    getProductLocation () {
      get('/index/product/produceLocation')
        .then(response => {
          this.locationList = response.data
          this.tabItems = [
            {
              key: this.locationList.filter(item => item.showName === 'China').map(item => item.id).join(','),
              tag: 'cn',
              icon: require('../assets/china.png'),
              label: 'Made in China',
              count: this.cnProductNumber
            },
            {
              key: this.locationList.filter(item => item.showName !== 'China').map(item => item.id).join(','),
              tag: 'other',
              icon: require('../assets/europe.png'),
              label: 'EU/USA Made',
              count: this.otherProductNumber
            }
          ]
          this.countryOptions = []
          const nonChinaIds = this.locationList.filter(item => item.showName !== 'China').map(item => item.id).join(',')
          nonChinaIds && this.countryOptions.push({
            key: nonChinaIds,
            tag: 'us-de',
            icon: null,
            label: 'All shipping regions',
            count: 0
          })
          const usIds = this.locationList.filter(item => item.showName === 'United States').map(item => item.id).join(',')
          usIds && this.countryOptions.push({
            key: usIds,
            tag: 'us',
            icon: require('../assets/usa.png'),
            label: 'U.S.A',
            count: 0
          })
          const deIds = this.locationList.filter(item => item.showName === 'Germany').map(item => item.id).join(',')
          deIds && this.countryOptions.push({
            key: deIds,
            tag: 'de',
            icon: require('../assets/deutsch.png'),
            label: 'Germany',
            count: 0
          })
          const frIds = this.locationList.filter(item => item.showName === 'France').map(item => item.id).join(',')
          frIds && this.countryOptions.push({
            key: frIds,
            tag: 'fr',
            icon: require('../assets/france.png'),
            label: 'France',
            count: 0
          })
          this.initFromUrlParams()
          this.queryParam.locationIds = this.isChina ? this.currentLocationIds : this.currentValueLocationIds
          this.getCategoryList().then(() => {
            this.getProductList(0)
            this.filtersBootstrapped = true
          }).catch(error => {
            this.filtersBootstrapped = true
            this.spinning = false
            console.error(error)
          })
        })
        .catch(error => {
          this.filtersBootstrapped = true
          this.spinning = false
          console.error(error)
        })
    },

    getCategoryList () {
      return get('/index/product/category/v2', {isChina: this.isChina})
        .then(response => {
          this.tabItems.forEach(item => {
            if (item.label === 'Made in China') {
              item.count = response.data.cnProductNumber
            } else if (item.label === 'EU/USA Made') {
              item.count = response.data.otherProductNumber
            }
          })

          function getCount (key) {
            let total = 0
            const ids = key.split(',')
            for (let id of ids) {
              total += response.data.otherLocationNumberMap[id] || 0
            }
            return total
          }

          this.countryOptions = this.countryOptions.map(item => ({
            ...item,
            count: getCount(item.key)
          }))
          this.menuData = [...response.data.children]
          this.shopList = [...response.data.children]
          this.pausedProductNumber = response.data.pausedProductNumber || 0
          const menuImageMap = {
            'Clothing': '/website/shop_clothing.png',
            'Home & Living': '/website/shop_living.png',
            'Accessories': '/website/shop_acces.png',
            'Outdoor': '/website/shop_outdoor.png',
            'Shoes': '/website/shop_shoes.png',
            'Automotive': '/website/shop_auto.png',
            'Drinkware': '/website/shop_drinkware.png',
            'Gifts': '/website/shop_gifts.png'
          }
          this.shopList.forEach(menu => {
            menu.img = menuImageMap[menu.name]
          })
          this.menuData.unshift({
            id: '',
            name: 'All products',
            children: [],
            productNumber: response.data.productNumber
          })
          this.rootSubmenuKeys = response.data.children.map(item => item.id)
          const urlParams = new URLSearchParams(window.location.search)
          const urlCategoryId = urlParams.get('categoryId') || this.$route.query.categoryId
          this.queryParam.categoryId = urlCategoryId || this.queryParam.categoryId

          this.hotSaleEnabled = !!response.data.hotSaleEnabled
          const path = window.location.pathname || ''
          const needExitTopPicks = !this.hotSaleEnabled && path.includes('/top-picks')
          const isTopPicksPath = this.hotSaleEnabled && path.includes('/top-picks')
          const isWishlistPath = path.includes('/wishlist')
          const isPausedPath = path.includes('/paused') || String(this.queryParam.status) === '2'
          if (isTopPicksPath) {
            this.isTopPicks = true
            this.queryParam.status = 0
            this.menuTitle = 'Top Picks'
            this.selectNames = ['Top Picks']
            this.queryParam.categoryId = undefined
            this.selectedKeys = []
            this.openKeys = []
          } else if (isWishlistPath) {
            this.isTopPicks = false
            this.queryParam.status = 0
            this.menuTitle = 'Wishlist'
            this.selectNames = ['Wishlist']
            this.queryParam.categoryId = undefined
            this.selectedKeys = []
            this.openKeys = []
            try {
              this.collectIds = JSON.parse(localStorage.getItem('collectIds') || '[]') || []
            } catch (e) {
              this.collectIds = []
            }
            this.queryParam.productIds = this.collectIds.length <= 0 ? ['mmmmmmmmmm'] : this.collectIds
          } else if (isPausedPath) {
            this.isTopPicks = false
            this.queryParam.status = 2
            this.menuTitle = 'Paused'
            this.selectNames = ['Paused']
            this.queryParam.categoryId = undefined
            this.selectedKeys = []
            this.openKeys = []
          } else {
            this.isTopPicks = false
            this.menuTitle = 'All products'
            this.selectNames = [this.menuTitle]
          }

          this.menuData.forEach(l1 => {
            this.expandedMenu.set(l1.id, [l1.id])
            this.expandedMenuName.set(l1.id, [getSeoLinkName(l1.name), `/products/category/${getSeoLinkName(l1.name)}`])
            if (l1.children) {
              l1.children.forEach(l2 => {
                this.expandedMenu.set(l2.id, [l1.id, l2.id])
                if (l2.parentId !== null) {
                  this.expandedMenuName.set(l2.id, [
                    getSeoLinkName(l1.name),
                    getSeoLinkName(l2.name),
                    `/products/category/${getSeoLinkName(l1.name)}/${getSeoLinkName(l2.name)}`
                  ])
                }
                if (l2.children) {
                  l2.children.forEach(l3 => {
                    this.expandedMenu.set(l3.id, [l1.id, l2.id, l3.id])
                    this.expandedMenuName.set(l3.id, [
                      getSeoLinkName(l1.name),
                      getSeoLinkName(l2.name),
                      getSeoLinkName(l3.name),
                      `/products/category/${getSeoLinkName(l1.name)}/${getSeoLinkName(l2.name)}/${getSeoLinkName(l3.name)}`
                    ])
                  })
                }
              })
            }
          })
          if (!isTopPicksPath && !isWishlistPath && !isPausedPath) {
            const hrefUrl = new URL(location.href)
            let selectId = findKeyByValue(this.expandedMenuName, hrefUrl.pathname)
            this.queryParam.categoryId = this.queryParam.categoryId || selectId
            const topLevelParentId = findTopLevelParentId(this.menuData, this.queryParam.categoryId)
            this.menuData.forEach(l1 => {
              l1['menuOpen'] = topLevelParentId === l1.id
              l1['grade'] = 1
              if (this.queryParam.categoryId === l1.id) {
                this.menuTitle = l1.name
                this.selectNames = [l1.name]
                this.openKeys = [l1.id]
                this.selectedKeys = [l1.id]
              }
              if (l1.children) {
                l1.children.forEach(l2 => {
                  l2['submenuOpen'] = this.queryParam.categoryId === l2.id
                  l2['grade'] = 2
                  if (this.queryParam.categoryId === l2.id) {
                    this.menuTitle = l2.name
                    if (l2.parentId !== null) this.selectNames = [l1.name, l2.name]
                    this.openKeys = [l1.id, l2.id]
                    this.selectedKeys = [l2.id]
                  }
                  if (l2.children) {
                    l2.children.forEach(l3 => {
                      l3['submenuOpen'] = this.queryParam.categoryId === l3.id
                      l3['grade'] = 3
                      if (this.queryParam.categoryId === l3.id) {
                        this.menuTitle = l3.name
                        this.selectNames = [l1.name, l2.name, l3.name]
                        this.openKeys = [l1.id, l2.id, l3.id]
                        this.selectedKeys = [l3.id]
                      }
                    })
                  }
                })
              }
            })
            let menuList = getItemsById(this.menuData, topLevelParentId)
            this.openKeys = setOpenKeys(menuList)
            this.isSelectedMenu = window.location.pathname.includes('/category/') || !!this.queryParam.categoryId
            if (this.isSelectedMenu) {
              this.selectedKeys = [String(this.queryParam.categoryId || '')]
            } else {
              this.selectedKeys = ['']
            }
          } else {
            this.menuData.forEach(l1 => {
              l1['menuOpen'] = false
              l1['grade'] = 1
              if (l1.children) {
                l1.children.forEach(l2 => {
                  l2['submenuOpen'] = false
                  l2['grade'] = 2
                  if (l2.children) {
                    l2.children.forEach(l3 => {
                      l3['submenuOpen'] = false
                      l3['grade'] = 3
                    })
                  }
                })
              }
            })
            this.isSelectedMenu = true
          }
          this.selectNames.unshift('Products')
          this.queryParam.pageNum = 1
          if (needExitTopPicks) {
            this.setNewUrl('')
            this.getProductList(0)
          }
          // 移除：getCategoryList内部不再调用getProductList，避免重复请求
        })
        .catch(error => console.error(error))
    },

    onProductTagsLoaded (children) {
      this.tagsList = children || []
    },

    getProductList (type) {
      this.spinning = true
      const isPaused = String(this.queryParam.status) === '2'
      const url = (!isPaused && this.isTopPicks && this.hotSaleEnabled)
        ? '/index/hotSaleProduct/search'
        : '/index/product/search'
      post(url, this.queryParam)
        .then(response => {
          this.dataList = response.data.list
          this.total = response.data.total
          this.dataList.forEach(item => {
            if (!item.productTemplateImg) item['productTemplateImg'] = item.productImg
            const {specColorOptionVOS, specOptionsVOS} = item
            const spec = (specColorOptionVOS || []).map(({
              colorOptionVOList,
              specsName
            }) => `${colorOptionVOList.length} ${specsName}`).join(' ')
            const spec1 = (specOptionsVOS || []).map(({
              optionNames,
              specsName
            }) => `${optionNames.length} ${specsName}`).join(' ')
            item.spec = `${spec} ${' '.repeat(3)} ${spec1}`
          })
          this.spinning = false
          if (type !== 0) this.onScrollTo()
        })
        .catch(error => {
          this.spinning = false
          console.error(error)
        })
    },

    onScrollTo () {
      const element = document.getElementsByClassName('product_tab')[0]
      if (!element) return
      let height = 90
      const rect = element.getBoundingClientRect()
      const scrollOptions = {
        left: rect.left + window.scrollX,
        top: rect.top + window.scrollY - height,
        behavior: 'smooth'
      }
      window.scrollTo(scrollOptions)
    },

    isShowTag (item, name) {
      return (item.tagList && item.tagList.some(item => item.showName && item.showName.toLowerCase() === name.toLowerCase())) || false
    },

    onSizeChange (current, size) {
      this.queryParam.pageNum = 1
      this.queryParam.pageSize = size
      this.getProductList()
    },

    changeSize (current, pageSize) {
      this.queryParam.pageNum = current
      this.queryParam.pageSize = pageSize
      this.getProductList()
    },

    checkBoxOnChange (e) {
      this.queryParam.categoryId = undefined
      this.queryParam.productIds = []
      this.queryParam.status = 0
      this.openKeys = []
      this.selectedKeys = []
      this.menuData.forEach(item => {
        item.menuOpen = false
      })
      if (e.target.checked) {
        this.queryParam.tagIds.push(e.target.value)
      } else {
        this.queryParam.tagIds = this.queryParam.tagIds.filter(item => e.target.value !== item)
      }
      if (!this.isTopPicks) {
        this.menuTitle = 'All products'
        this.selectNames = ['Products', this.menuTitle]
        this.selectedKeys = [String('')]
        this.setNewUrl('')
      } else {
        this.menuTitle = 'Top Picks'
        this.selectNames = ['Products', this.menuTitle]
        this.setTopPicksUrl()
      }
      this.queryParam.pageNum = 1
      this.getProductList()
    },

    handleItemClick (key, isUnfold, level, menu) {
      let menuList = getItemsById(this.menuData, key)
      if (isUnfold === 0 || isUnfold === 4) {
        this.openKeys = this.openKeys.includes(key) ? [] : setOpenKeys(menuList)
      }
      if (isUnfold !== 0) {
        this.isTopPicks = false
        this.queryParam.tagIds = []
        this.queryParam.productIds = []
        this.queryParam.status = 0
        this.setNewUrl(key)
        this.menuData.forEach(l1 => {
          unSubmenus(l1.children)
        })
        this.selectedKeys = [String(key)]
        if (key === '') this.openKeys = []
        if (isUnfold === 2) this.menuData.forEach(item => item.menuOpen = false)
        this.selectNames = getNamesById(this.menuData, key)
        this.menuTitle = menuList[0].name
        this.selectNames.unshift('Products')
        this.queryParam.pageNum = 1
        this.queryParam.categoryId = key
        this.updateUrlParams()
        this.getProductList(key)
        if (level !== 2) menu && menu.children.forEach(item => item.submenuOpen = false)
        menu && menu.children.forEach(item => {
          item.submenuOpen = key === item.id
        })
      }
      if (isUnfold === 0 || isUnfold === 4 || key === '') {
        this.menuData.forEach(item => {
          item.menuOpen = item.id === key ? !item.menuOpen : false
        })
      }
      EventBus.$emit('animationEvent')
    },

    setNewUrl (key) {
      let names = this.expandedMenuName.get(key)
      let namesCopy = names.slice(0, -1)
      let urlParams = namesCopy.join('/')
      const href = new URL(location.origin)
      const newUrl = urlParams === 'all-products'
        ? `${href}products/category/all-products${this.getUrlParamsString()}`
        : `${href}products/category/${urlParams}${this.getUrlParamsString()}`
      window.history.pushState({}, '', newUrl)
      this.isSelectedMenu = window.location.pathname.includes('/category/')
      this.syncUrlProductName()
      this.syncPathSeo()
    },

    toDetailsDes (item) {
      window.open(`/products/${item.seoCustomerAddress}`, '_blank')
    },
    collect (id) {
      this.collectIds = this.collectIds || []
      const isCollect = this.collectIds.includes(id)

      if (isCollect) {
        this.collectIds = this.collectIds.filter(item => item !== id)
        if (this.menuTitle === 'Wishlist') {
          this.queryParam.productIds = this.collectIds.length <= 0 ? ['mmmmmmmmmm'] : this.collectIds
          this.getProductList(0)
        }
      } else {
        this.collectIds.push(id)
      }
      localStorage.setItem('collectIds', JSON.stringify(this.collectIds))
    },
  }
}
</script>


<style lang="less">
.search-keyword-tag.ant-tag {
  max-width: 180px;
  height: 26px;
  line-height: 25px;
  padding: 0 10px;
  display: inline-flex;
  align-items: center;
  vertical-align: middle;
  font-weight: 500;
  font-size: 15px;
  color: #222222;
  background: #F1F5F9;
  border-radius: 6px;
  border: 1px solid #E5E7EB;
}

.search-keyword-tag.ant-tag .search-keyword-quote {
  flex-shrink: 0;
}

.search-keyword-tag.ant-tag .search-keyword-text {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  min-width: 0;
  flex: 1;
}

.search-keyword-tag.ant-tag .search-keyword-close {
  width: 10px;
  height: 10px;
  margin-left: 10px;
  flex-shrink: 0;
  cursor: pointer;
}
</style>
<style scoped lang="less">

.content-product {
  display: flex;
  flex-direction: column;
  //margin-top: 72px;
  font-family: HarmonyOS Sans SC;

  /deep/ .ant-menu:not(.ant-menu-horizontal) .ant-menu-item-selected {
    background-color: #FFFFFF;
  }

  //菜单左侧竖线
  /deep/ .ant-menu-vertical .ant-menu-item::after, /deep/ .ant-menu-vertical-left .ant-menu-item::after, /deep/ .ant-menu-vertical-right .ant-menu-item::after, /deep/ .ant-menu-inline .ant-menu-item::after {
    left: 0;
    height: 30px;
    top: 5px;
    border-left: 3px solid #343183;
    border-right: 0;
    display: none;
  }

  //菜单打开状态/\箭头左/
  /deep/ .ant-menu-submenu-open.ant-menu-submenu-inline > .ant-menu-submenu-title > .ant-menu-submenu-arrow::before {
    width: 8px;
    display: none;
    transform: rotate(45deg) translateX(3.6px);
  }

  //菜单打开状态/\箭头右\
  /deep/ .ant-menu-submenu-open.ant-menu-submenu-inline > .ant-menu-submenu-title > .ant-menu-submenu-arrow::after {
    width: 8px;
    display: none;
    transform: rotate(-45deg) translateX(-3.6px);
  }

  //菜单收起状态\/箭头左\
  /deep/ .ant-menu-inline-collapsed .ant-menu-submenu-arrow::before, /deep/ .ant-menu-submenu-inline .ant-menu-submenu-arrow::before {
    width: 8px;
    display: none;
    transform: rotate(-45deg) translateX(3.6px);
  }

  //菜单收起状态\/箭头右/
  /deep/ .ant-menu-inline-collapsed .ant-menu-submenu-arrow::after, /deep/ .ant-menu-submenu-inline .ant-menu-submenu-arrow::after {
    width: 8px;
    display: none;
    transform: rotate(45deg) translateX(-3.6px);
  }


  /deep/ .ant-menu-inline, .ant-menu-vertical, .ant-menu-vertical-left {
    border-right: 1px solid transparent;
  }

  /deep/ .ant-checkbox-wrapper {
    font-size: 16px;
    color: #666666;
  }

  /deep/ .ant-menu-item {
    font-weight: 200;
  }

  /deep/ .ant-menu-item-selected {
    font-weight: 400;
  }

  .arrivals_box {
    width: 100%;
    display: flex;
    flex-direction: column;
    align-items: center;
    height: 300px;
    background: #FFFFFF;

    .title_box {
      width: 1280px;
      display: flex;
      justify-content: space-between;
      align-items: center;
      margin-top: 25px;


      .hot {
        font-weight: bold;
        font-size: 30px;
        color: #FF5C01;
        font-style: italic;
      }

      .title {
        font-weight: bold;
        font-size: 28px;
        color: #111111;
      }

      .des-wrapper {
        display: flex;
        justify-content: flex-end;
        padding: 10px 0 10px 30px;
        z-index: 10;
        cursor: pointer;
      }

      .des {
        font-weight: 400;
        font-size: 17px;
        color: #111111;
        display: inline-flex;
        align-items: center;
        transition: transform 0.6s ease;
      }

      .img {
        width: 16px;
        margin-left: 3px;
        height: 14px;
        transition: transform 0.6s ease;
      }

      .des-hover {
        transform: translateX(-4px);
      }

      .img-hover {
        transform: translateX(6px);
      }
    }

    .swiper_box {
      width: 1400px;
      height: 168px;
      display: flex;
      position: relative;
    }

    .button-prev {
      position: absolute;
      top: calc((100% + 5px) / 2);
      opacity: 0.6;
      left: 15px;
      cursor: pointer;
      transition: all ease 0.3s;
    }

    .button-prev:hover {
      opacity: 1;
    }

    .button-next {
      position: absolute;
      top: calc((100% + 5px) / 2);
      opacity: 0.6;
      right: 20px;
      cursor: pointer;
      transition: all ease 0.3s;
    }

    .button-next:hover {
      opacity: 1;
    }

    .swiper-container {
      width: 1280px;
      position: absolute;
      top: 50%;
      left: 50%;
      display: flex;
      transform: translate(-50%, -50%);

      .slide_box {
        width: 189px;
        height: 189px;
        background: #FFFFFF;
        border-radius: 10px;
        margin-top: 33px;
        cursor: pointer;
        display: flex;
        position: relative;
        margin-left: 1px;
        flex-direction: column;


        .img_box {
          width: 189px;
          height: 189px;
          display: flex;
          position: relative;
          border-radius: 10px;
          overflow: hidden;
          transition: all ease 0.3s;

          .img1 {
            width: 100%;
            height: 100%;
            opacity: 1;
            position: absolute;
            top: 0;
            transition: all ease 0.6s;
          }

          .img2 {
            width: 100%;
            height: 100%;
            opacity: 0;
            position: absolute;
            top: 0;
            transition: all ease 0.6s;
          }

        }

        .name {
          overflow: hidden;
          text-overflow: ellipsis;
          white-space: normal;
          -webkit-line-clamp: 1;
          display: -webkit-box;
          -webkit-box-orient: vertical;
          word-wrap: break-word;
          margin: 0 12px;
          font-weight: 500;
          font-size: 18px;
          color: #111111;
          line-height: 29px;
        }

        .price {
          overflow: hidden;
          text-overflow: ellipsis;
          white-space: normal;
          -webkit-line-clamp: 1;
          display: -webkit-box;
          -webkit-box-orient: vertical;
          word-wrap: break-word;
          margin: 0 12px;
          font-weight: 400;
          font-size: 16px;
          color: #111111;
          line-height: 31px;
        }

        .label {
          width: 64px;
          height: 30px;
          border-image: linear-gradient(0deg, #588ABD, #C8DFF9) 10 10;
          border-radius: 6px;
          font-weight: bold;
          position: absolute;
          top: 5px;
          left: 5px;
          font-size: 16px;
          color: #FFFFFF;
          line-height: 30px;
        }
      }

      .slide_box:hover .img_box .img1 {
        opacity: 0;
        transform: scale(1.05);
      }

      .slide_box:hover .img_box .img2 {
        opacity: 1;
        transform: scale(1.05);
      }


    }
  }

  .product_tab {
    /deep/ .ant-tabs-bar {
      height: 46px;
      padding-left: 310px;
      margin-bottom: 0;
    }

    /deep/ .ant-tabs.ant-tabs-card .ant-tabs-card-bar {
      .ant-tabs-nav-container {
        height: 46px;
      }

      .ant-tabs-tab {
        height: 46px;
        padding: 0 22px;
        transition: all 0.3s;
        display: inline-flex;
        align-items: center;
        margin-right: 10px;
        justify-content: center;
        background: #EFF5F8;
        color: #111111;

        .ant-tabs-tab-inner {
          display: flex;
          align-items: center;
          line-height: normal;
        }

        .tab-item {
          display: flex;
          align-items: center;
          gap: 8px;
          height: 100%;
        }

        .hot {
          position: absolute;
          right: 0;
          top: 0;
        }

        &.ant-tabs-tab-active {
          color: #012169;
          background: #FFFFFF;

          .tab-item {
            color: #012169;
          }
        }

        &:hover {
          color: #012169;
        }
      }
    }
  }

  .wishlist {
    margin-left: 25px;

    .wishlist-name {
      font-weight: bold;
      font-size: 18px;
      cursor: pointer;
      color: #222222;
    }
  }

  .top-picks {
    margin-left: 25px;
    margin-top: 23px;

    .top-picks-name {
      font-weight: bold;
      font-size: 18px;
      cursor: pointer;
      color: #222222;
    }
  }

  .wishlist-divider {
    width: 202px;
    height: 1px;
    background: #D2D2D2;
    margin-top: 30px;
    margin-bottom: 18px;
  }

  .paused {
    margin-left: 25px;

    .paused-divider {
      width: 202px;
      height: 1px;
      background: #D2D2D2;
      margin-top: 20px;
      margin-bottom: 25px;
    }

    .paused-name {
      font-weight: bold;
      font-size: 18px;
      cursor: pointer;
      color: #222222;
    }
  }

  .product_box {
    padding: 30px 320px 50px 290px;
    background: #FFFFFF;

    /deep/ .ant-pagination-item-active {
      font-weight: 500;
      background: #343183;
    }

    /deep/ .ant-pagination-item-active a {
      color: #FFFFFF;
    }

    .divider {
      height: 1px;
      margin: 30px 32px 25px 20px;
      background: #D2D2D2;
    }

    .tags_box {
      margin-left: 20px;
    }

    .tags_item {
      display: flex;
      align-items: center;
      height: 45px;
      cursor: pointer;
      transition: background-color 0.2s ease;
    }

    .item_name {
      font-weight: bold;
      font-size: 18px;
      padding-left: 6px;
      color: #111111;
      display: flex;
      align-items: center;
      transition: all 0.3s ease;
    }

    .item_divider {
      width: 4px;
      height: 20px;
      background: #012169;
    }

    //.item_name::before {
    //  content: "|";
    //  margin-right: 10px;
    //  color: var(--separator-color, transparent);
    //  font-weight: 900;
    //  transition: color 0.3s ease;
    //}

    .menu3:hover {
      text-decoration: underline;
      text-underline-offset: 4px;
      text-decoration-color: #012169;
      color: #012169 !important;
    }

    .menu:hover {
      text-decoration: underline;
      text-decoration-color: #012169;
      text-underline-offset: 4px;
      color: #012169 !important;
    }

    .selected-menu3 {
      color: #012169 !important;
    }

    .selected-menu3::before {
      content: "|";
      font-size: 20px;
      position: absolute;
      left: 55px;
      color: #012169;
      font-weight: 900;
    }

    .selected-menu2 {
      color: #012169 !important;
    }

    .selected-menu2::before {
      content: "|";
      font-size: 20px;
      position: absolute;
      left: 30px;
      color: #012169;
      font-weight: 900;
    }

    .selected-menu1 {
      color: #012169 !important;
    }

    .selected-menu1::before {
      content: "|";
      font-size: 20px;
      position: absolute;
      left: 30px;
      color: #012169;
      font-weight: 900;
    }

    .selected-menu::before {
      content: "|";
      font-size: 20px;
      margin-right: 12px;
      color: #012169;
      font-weight: 900;
    }

    .shop_view {
      width: 1030px;
      display: flex;
      margin-bottom: 25px;
      flex-direction: column;

      .title {
        font-weight: bold;
        font-size: 26px;
        text-align: center;
        color: #111111;
      }

      .shop_list {
        width: 1030px;
        margin-top: 28px;
        display: flex;
        flex-wrap: wrap;
        gap: 12px;
        position: relative;

        .shop_box:hover {
          .name {
            text-decoration: underline;
            text-decoration-color: #012169;
            color: #012169;
            text-decoration-thickness: 1px;
            text-underline-offset: 4px;
          }
        }

        .shop_box {
          width: 248px;
          height: 300px;
          cursor: pointer;
          display: flex;
          position: relative;
          flex-direction: column;

          .name {
            width: 232px;
            overflow: hidden;
            text-overflow: ellipsis;
            white-space: normal;
            -webkit-line-clamp: 1;
            display: -webkit-box;
            -webkit-box-orient: vertical;
            word-wrap: break-word;
            text-align: center;
            font-weight: bold;
            font-size: 20px;
            color: #111111;
            line-height: 40px;
          }

          .img_box {
            width: 248px;
            height: 248px;
            position: relative;
            overflow: hidden;
            transition: all ease 0.3s;

            .img1 {
              width: 100%;
              height: 100%;
              opacity: 1;
              position: absolute;
              top: 0;
              transition: all ease 0.6s;
            }

            .img2 {
              width: 100%;
              height: 100%;
              opacity: 0;
              position: absolute;
              top: 0;
              transition: all ease 0.6s;
            }

          }
        }
      }
    }

    .empty_box {
      width: 1030px;
      margin-top: 7%;
      display: flex;
      align-items: center;
      justify-content: center
    }

    .product_view {
      width: 1030px;
      display: flex;
      margin-bottom: 45px;
      flex-direction: column;

      .title {
        font-weight: bold;
        text-align: center;
        font-size: 26px;
        color: #111111;
      }

      .label_box {
        width: 1030px;
        display: flex;
        flex-direction: row;
        height: 30px;
        align-items: center;
        justify-content: space-between;

        .label {
          display: flex;
          flex-direction: row;
          max-width: 800px;
          line-height: 36px;
          font-weight: 400;
          font-size: 18px;
          color: #111111;
        }

        .checkbox_group {
          flex-wrap: wrap;
          display: flex;
        }
      }

      .filtrate_box {
        width: 1030px;
        display: flex;
        height: 40px;
        margin-top: 25px;
        align-items: center;
        justify-content: space-between;
        border-radius: 10px;
        padding-right: 5px;

        .filtrate-selects {
          display: flex;
          margin-left: auto;
        }

        /deep/ .ant-select {
          color: #111111;
          font-weight: 400;
          font-size: 14px;
          font-family: HarmonyOS Sans SC;
        }

        /deep/ .ant-select-selection__placeholder, .ant-select-search__field__placeholder {
          color: #111111;
        }

        .select_view {
          width: 150px;
          cursor: pointer;
          padding: 20px 8px;
          display: flex;
        }

        .check_icon {
          display: none;
        }

        .checkbox_group {
          flex-wrap: wrap;
          display: flex;
          gap: 25px;

          > div:first-child {
            /deep/ .ant-checkbox-checked .ant-checkbox-inner::after {
              content: " " !important;
              border: 2px solid #FF5C01 !important;
              border-top: 0 !important;
              border-left: 0 !important;
            }

            /deep/ .ant-checkbox-inner {
              background-color: #FDEAC8 !important;
              border-color: #FF5C01 !important;
            }

            /deep/ .ant-checkbox-checked .ant-checkbox-inner {
              background-color: #FDEAC8 !important;
              border-color: #FF5C01 !important;
            }

            /deep/ .ant-checkbox:hover .ant-checkbox-inner {
              border-color: #FF5C01 !important;
            }
          }

          > div:nth-child(2) {
            /deep/ .ant-checkbox-checked .ant-checkbox-inner::after {
              content: " " !important;
              border: 2px solid #0B550F !important;
              border-top: 0 !important;
              border-left: 0 !important;
            }

            /deep/ .ant-checkbox-inner {
              background-color: #D9FDD6 !important;
              border-color: #0B550F !important;
            }

            /deep/ .ant-checkbox-checked .ant-checkbox-inner {
              background-color: #D9FDD6 !important;
              border-color: #0B550F !important;
            }

            /deep/ .ant-checkbox:hover .ant-checkbox-inner {
              border-color: #0B550F !important;
            }
          }

          > div:nth-child(3) {
            /deep/ .ant-checkbox-checked .ant-checkbox-inner::after {
              content: " " !important;
              border: 2px solid #5F2282 !important;
              border-top: 0 !important;
              border-left: 0 !important;
            }

            /deep/ .ant-checkbox-inner {
              background-color: #F0DDFF !important;
              border-color: #5F2282 !important;
            }

            /deep/ .ant-checkbox-checked .ant-checkbox-inner {
              background-color: #F0DDFF !important;
              border-color: #5F2282 !important;
            }

            /deep/ .ant-checkbox:hover .ant-checkbox-inner {
              border-color: #5F2282 !important;
            }
          }
        }

        .custom-radio-group {
          display: flex;
          gap: 10px;
          flex-wrap: wrap;

          /deep/ .ant-radio-button-wrapper {
            padding: 0 15px !important;
            height: 39px !important;
            background: #EFF5F8 !important;
            border-radius: 20px !important;
            border: none !important;
            line-height: 39px !important;
            text-align: center;
            font-weight: 400;
            font-size: 16px;
            margin: 0 !important;
            box-shadow: none !important;

            &::before {
              display: none !important;
            }


            &:not(.ant-radio-button-wrapper-checked) {
              background: #EFF5F8 !important;

              &:hover {
                background: #EFF5F8 !important;
              }
            }

            &.ant-radio-button-wrapper-checked {
              background: #C5FAFF !important;
              box-shadow: none !important;

              &:hover {
                background: #C5FAFF !important;
                box-shadow: none !important;
              }
            }

            .radio-content {
              display: flex;
              align-items: center;
              justify-content: center;
              gap: 8px;
              width: 100%;
              height: 100%;
            }
          }
        }

        /deep/ .ant-radio-button-wrapper {
          &.ant-radio-button-wrapper-checked {
            background: #EFF5F8 !important;
            box-shadow: none !important;

            &:hover {
              background: #EFF5F8 !important;
              box-shadow: none !important;
            }
          }
        }
      }

      .total_box {
        font-weight: 400;
        font-size: 16px;
        line-height: 24px;
        height: 24px;
        color: #646464;
        margin-top: 10px;
        display: flex;
        align-items: center;
        flex-wrap: wrap;
        gap: 8px;

        .search-keyword-tag {
          margin: 0;
          max-width: 180px;
        }
      }


      .product_list {
        width: 1030px;
        margin-top: 20px;
        margin-bottom: 30px;
        display: flex;
        flex-wrap: wrap;
        gap: 24px;
        position: relative;

        .list_box:hover {
          background: rgba(227, 227, 227, 0.5);
          transition: all ease 0.3s;
        }

        .list_box:hover .product-operate {
          opacity: 1;
          transition: all ease 0.6s;
        }


        .list_box {
          width: 239px;
          height: 364px;
          cursor: pointer;
          display: flex;
          position: relative;

          flex-direction: column;
          background: #FFFFFF;

          .img_box {
            width: 239px;
            height: 239px;
            position: relative;
            overflow: hidden;
            transition: all ease 0.3s;

            .img1 {
              width: 100%;
              height: 100%;
              opacity: 1;
              position: absolute;
              top: 0;
              transition: all ease 0.6s;
            }

            .img2 {
              width: 100%;
              height: 100%;
              opacity: 0;
              position: absolute;
              top: 0;
              transition: all ease 0.6s;
            }

          }

          .name {
            width: 223px;
            overflow: hidden;
            text-overflow: ellipsis;
            white-space: normal;
            -webkit-line-clamp: 1;
            display: -webkit-box;
            -webkit-box-orient: vertical;
            word-wrap: break-word;
            margin: 12px 8px 8px 8px;
            font-weight: 500;
            font-size: 18px;
            color: #111111;
          }

          .size {
            width: 223px;
            overflow: hidden;
            text-overflow: ellipsis;
            white-space: normal;
            -webkit-line-clamp: 1;
            display: -webkit-box;
            -webkit-box-orient: vertical;
            word-wrap: break-word;
            margin: 0 8px;
            font-weight: 400;
            font-size: 16px;
            color: #888A96;
            line-height: 21px;
          }

          .price {
            width: 223px;
            overflow: hidden;
            text-overflow: ellipsis;
            white-space: normal;
            -webkit-line-clamp: 1;
            display: -webkit-box;
            -webkit-box-orient: vertical;
            word-wrap: break-word;
            margin: 0 8px;
            line-height: 33px;
            font-weight: 500;
            font-size: 18px;
            color: #111111;
          }

          .tag_box {
            display: flex;
            position: absolute;
            height: 19px;
            top: 10px;
            left: 6px;
            font-family: HarmonyOS Sans SC;
            font-weight: 400;

            .best {
              height: 19px;
              background: #5F2282;
              border-radius: 3px;
              padding: 0 5px;
              font-size: 14px;
              line-height: 17px;
              margin-right: 3px;
              text-align: center;
              color: #F0DDFF;
            }

            .new {
              height: 19px;
              background: #FF5C01;
              border-radius: 3px;
              padding: 0 5px;
              font-size: 14px;
              line-height: 17px;
              margin-right: 3px;
              text-align: center;
              color: #FDF1D0;
            }

            .trd {
              height: 19px;
              background: #0B550F;
              border-radius: 3px;
              padding: 0 5px;
              font-size: 14px;
              line-height: 17px;
              text-align: center;
              color: #D9FDD6;
            }
          }

          .product-operate {
            position: absolute;
            right: 11px;
            top: 9px;
            opacity: 0;
            display: flex;
            flex-direction: column;


            .collection {
              width: 30px;
              height: 30px;
              background-image: url(../assets/collect-icon.png);
              background-size: 100% 100%;
            }

            .collected {
              background-image: url(../assets/collected-icon.png);
            }
          }
        }

        .list_box:hover .img_box .img1 {
          opacity: 0;
          transform: scale(1.1);
        }

        .list_box:hover .img_box .img2 {
          opacity: 1;
          transform: scale(1.1);
        }

      }

      .pagination {
        width: 1030px;
        display: flex;
        margin-top: 10px;
        justify-content: end;


        /deep/ .ant-pagination {
          font-family: HarmonyOS Sans SC;
          font-weight: 400;
          font-size: 16px;
          color: #111111;

          .anticon {
            font-family: HarmonyOS Sans SC;
            color: #D2D2D2;
          }
        }

        /deep/ .ant-pagination-item a {
          font-family: HarmonyOS Sans SC;
          font-size: 16px;
          color: #111111;
        }

        /deep/ .ant-pagination-item-active a {
          font-family: HarmonyOS Sans SC;
          background: #FFFFFF;
          color: #012169;
          border-radius: 5px;
        }

        /deep/ .ant-select {
          font-family: HarmonyOS Sans SC;
          font-weight: 400;
          font-size: 16px;
          color: #111111;
        }
      }

    }

  }
}

</style>



// WEBPACK FOOTER //
// src/views/Products.vue